import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dd1c835"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "right fas fa-angle-left"
}
const _hoisted_2 = {
  key: 0,
  class: "nav nav-treeview"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppMenuItem = _resolveComponent("AppMenuItem")!

  return (_openBlock(), _createElementBlock("li", {
    class: _normalizeClass(["nav-item", { 'menu-open': _ctx.isOpen }])
  }, [
    _createElementVNode("a", {
      href: "#",
      class: _normalizeClass(["nav-link", { active: _ctx.isActive }]),
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleClick && _ctx.handleClick(...args)), ["prevent"]))
    }, [
      (_ctx.menuItem.icon)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: _normalizeClass(["nav-icon", _ctx.menuItem.icon])
          }, null, 2))
        : _createCommentVNode("", true),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.menuItem.name) + " ", 1),
        (_ctx.isExpandable)
          ? (_openBlock(), _createElementBlock("i", _hoisted_1))
          : _createCommentVNode("", true)
      ])
    ], 2),
    (_ctx.isExpandable)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.children, (item) => {
            return (_openBlock(), _createBlock(_component_AppMenuItem, {
              key: item.key,
              menuItem: item,
              level: _ctx.level + 1
            }, null, 8, ["menuItem", "level"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}